import {IconSizeTokens, IconTokens} from '@voltmoney/schema';
import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {Icon} from '@voltmoney/component';

interface NoInternetProps {
  onPress: () => void;
}
const PageNotFound = ({onPress}: NoInternetProps) => {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
      }}>
      {/*<Icon.Component name={IconTokens.NoNetwork} size={IconSizeTokens.XXS} />*/}
      <Text style={styles.title}>{'404 Error'}</Text>
      <Text style={styles.description}>
        {'Sorry, this page is not available'}
      </Text>
      {/*<TouchableOpacity style={styles.button} onPress={onPress}>*/}
      {/*  <Text style={styles.buttonText}>Try again</Text>*/}
      {/*</TouchableOpacity>*/}
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 24,
    lineHeight: 32,
    fontWeight: '700',
    color: 'black',
    marginTop: 32,
  },
  description: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '400',
    color: 'black',
    textAlign: 'center',
  },
  button: {
    borderRadius: 22,
    backgroundColor: 'blue',
    width: 232,
    height: 48,
    marginTop: 32,
    color: 'blue',
    justifyContent: 'center',
  },
  buttonText: {
    alignSelf: 'center',
    color: 'white',
    fontSize: 16,
    fontWeight: '700',
  },
});

export default PageNotFound;
